import { ENDPOINT } from '../../constants/server/api';
import { fetchApiData } from '../../utils/apiUtils';
import { setBusinesses, setCustomer } from '../slices/customer.slice';

export const getCustomers = params => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/pagination/info`,
    params: {
      page: params?.page,
      perPage: params?.perPage,
      s: params?.s,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getCustomerById = id => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/${id}/info`,
    dispatch
  });

  if (data) {
    dispatch(setCustomer(data));
    return data;
  }
  return null;
};

export const updateCustomer = (id, values) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/${id}/info`,
    data: {
      prefixNameId: values.prefixNameId,
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      userBusinessCustomerGroupId: values.userBusinessCustomerGroupId
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateCustomerPassword = (id, password) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/${id}/password`,
    data: { password },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateCustomerEmail = (id, email) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/${id}/email`,
    data: { email },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateCustomerGoogleId = (id, googleId) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/${id}/google-id`,
    data: { googleId },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const requestResetPassword = email => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.SA_USER_BUSINESS_GROUP}/reset-password-request`,
    data: { email },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const exportCustomerToExcel = searchTerm => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.CUSTOMER}/excel/info`,
    params: {
      s: searchTerm || ''
    },
    responseType: 'blob',
    dispatch
  });

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'รายการลูกค้า.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
  return null;
};

export const getUserBusinessGroupLogs = params => async dispatch => {
  if (params.business_group_id) {
    const data = await fetchApiData({
      method: 'get',
      endpoint: `${ENDPOINT.CUSTOMER}/log/pagination/list`,
      params: {
        business_group_id: params?.business_group_id,
        business_id: params?.business_id,
        type: params?.type,
        start_date: params?.start_date || '2024-01-01',
        end_date: params?.end_date || '2025-01-01',
        page: params?.page,
        perPage: params?.perPage,
        sortBy: params?.sortBy,
        sortOrder: params?.sortOrder
      },
      dispatch
    });

    if (data) {
      return data;
    }
  }
  return null;
};

export const exportUserBusinessGroupLogs = params => async dispatch => {
  if (params.business_group_id) {
    const data = await fetchApiData({
      method: 'post',
      endpoint: `${ENDPOINT.CUSTOMER}/log/excel`,
      params: {
        business_group_id: params.business_group_id,
        business_id: params.business_id,
        type: params.type,
        start_date: params.start_date || '2024-01-01',
        end_date: params.end_date || '2025-01-01'
      },
      responseType: 'blob',
      dispatch
    });

    if (data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ประวัติการดำเนินการ.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  }
  return null;
};

export const getBusinessList = params => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/business/list`,
    params: {
      business_group_id: params?.business_group_id,
      s: params?.s
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getBusinessPagination = params => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/business/pagination/list`,
    params: {
      business_group_id: params?.business_group_id,
      page: params?.page,
      perPage: params?.perPage,
      s: params?.s,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getBusinessById = id => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}`,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateBusinessInfo = (id, values) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}/info`,
    data: values,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateBusinessContact = (id, values) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}/contact`,
    data: values,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateBusinessSettings = (id, values) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}/settings`,
    data: values,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const exportBusinessToExcel = params => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.CUSTOMER}/business/excel`,
    params: {
      business_group_id: params?.business_group_id,
      s: params?.s
    },
    responseType: 'blob',
    dispatch
  });

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'รายการธุรกิจ.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
  return null;
};

export const getBusinessGroupList = params => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/business/list`,
    params: {
      business_group_id: params?.business_group_id,
      s: params?.s
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getBusinessGroupPagination = params => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/business/pagination/list`,
    params: {
      business_group_id: params?.business_group_id,
      page: params?.page,
      perPage: params?.perPage,
      s: params?.s,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const getBusinessGroupById = id => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}`,
    dispatch
  });

  if (data) {
    dispatch(setBusinesses(data));
    return data;
  }
  return null;
};

export const updateBusinessGroupInfo = (id, values) => async dispatch => {
  const formData = new FormData();

  const isHttpUrl = s => typeof s === 'string' && /^https?:\/\//i.test(s);
  const isDataUrl = s => typeof s === 'string' && /^data:image\/[a-zA-Z+.-]+;base64,/.test(s);

  const base64ToBlob = base64String => {
    if (!base64String) return null;

    const base64Body = base64String.includes('base64,') ? base64String.split('base64,')[1] : base64String;

    try {
      const binaryString = window.atob(base64Body);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i);
      return new Blob([bytes], { type: 'image/jpeg' });
    } catch {
      return null;
    }
  };

  const mappedValues = {
    subDistrictId: values.subDistrictId ?? values.settingSubDistrictId,
    restaurantTypeId: values.restaurantTypeId ?? values.settingRestaurantTypeId,
    shopProductCategoryTypeId: values.shopProductCategoryTypeId ?? values.settingShopProductCategoryTypeId,
    entityTypeId: values.entityTypeId ?? values.settingEntityTypeId,
    prefixNameId: values.prefixNameId ?? values.settingPrefixNameId,
    taxNumber: values.taxNumber ?? values.settingTaxNumber,
    firstName: values.firstName ?? values.settingFirstName,
    lastName: values.lastName ?? values.settingLastName,
    address: values.address ?? values.settingAddress,
    slug: values.slug ?? values.settingSlug,
    companyName: values.companyName ?? values.settingCompanyName,
    imagePath: values.imagePath
  };
  Object.entries(mappedValues).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') {
      if (key === 'imagePath') {
        if (isDataUrl(val)) {
          const blob = base64ToBlob(val);
          if (blob) formData.append('imagePath', blob, 'image.jpg');
        } else if (isHttpUrl(val)) {
          formData.append('imagePath', val);
        }
      } else {
        formData.append(key, val);
      }
    }
  });

  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}/info`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    dispatch
  });

  return data || null;
};

export const updateBusinessGroupContact = (id, values) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}/contact`,
    data: values,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateBusinessGroupSettings = (id, values) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}/settings`,
    data: values,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const exportBusinessGroupToExcel = params => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.CUSTOMER}/business/excel`,
    params: {
      business_group_id: params?.business_group_id,
      s: params?.s
    },
    responseType: 'blob',
    dispatch
  });

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'รายการธุรกิจ.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
  return null;
};

export const createBusiness = values => async dispatch => {
  console.log('values : ', values);

  const formData = new FormData();

  const isHttpUrl = s => typeof s === 'string' && /^https?:\/\//i.test(s);
  const isDataUrl = s => typeof s === 'string' && /^data:image\/[a-zA-Z+.-]+;base64,/.test(s);

  const base64ToBlob = base64String => {
    if (!base64String) return null;

    const base64Body = base64String.includes('base64,') ? base64String.split('base64,')[1] : base64String;

    try {
      const binaryString = window.atob(base64Body);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) bytes[i] = binaryString.charCodeAt(i);
      return new Blob([bytes], { type: 'image/jpeg' });
    } catch {
      return null;
    }
  };

  const mapped = {
    businessGroupId: values.businessGroupId,
    subDistrictId: values.subDistrictId,
    restaurantTypeId: values.restaurantTypeId,
    shopProductCategoryTypeId: values.shopProductCategoryTypeId,
    entityTypeId: values.entityTypeId,
    prefixNameId: values.prefixNameId,
    prefixNameOther: values.prefixNameOther,
    taxNumber: values.taxNumber,
    address: values.address,
    slug: values.slug,
    userId: values.userId,
    imageSize: values.imageSize,
    firstName: values.firstName || '',
    lastName: values.lastName || '',
    companyName: values.companyName || ''
  };

  Object.entries(mapped).forEach(([k, v]) => {
    if (v !== undefined && v !== null) {
      formData.append(k, v);
    }
  });

  const { imagePath } = values || {};
  if (imagePath) {
    if (isDataUrl(imagePath)) {
      const blob = base64ToBlob(imagePath);
      if (blob) {
        formData.append('imagePath', blob, 'image.jpg');
      }
    } else if (isHttpUrl(imagePath)) {
      formData.append('imagePath', imagePath);
    }
  }

  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.CUSTOMER}/business/create`,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    dispatch
  });

  return data || null;
};

export const getPackageList = () => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PACKAGE}/list`,
    dispatch,
    useAuth: true
  });
  if (data) {
    return data;
  }
};

export const getPermissions = packageType => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PERMISSION}`,
    params: {
      packageType: packageType || 'MAIN'
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};
export const getPermissionsAdditionalByPackageMainId = packageMainId => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `${ENDPOINT.PERMISSION}/by-package`,
    params: {
      packageType: 'ADDITIONAL',
      packageMainId: packageMainId || null
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const createPackage = values => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.PACKAGE}`,
    data: {
      name: values.name,
      price_month: values.priceMonth,
      price_year: values.priceYear,
      is_not_show_customer: values.isNotShowCustomer,
      permissions: values.permissions.map(permission => ({
        permission_id: permission.permissionId,
        type: permission.type,
        permission: {
          qty: permission.qty,
          value: permission.value,
          is_infinite: permission.isInfinite,
          permission: permission.permission || {}
        }
      }))
    },
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};

export const changePackage = values => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `${ENDPOINT.CUSTOMER}/business/package-change`,
    data: {
      businessId: values.package,
      packageMainId: values.package,
      packageChangeResultId: Number(values.change_result),
      packageExpirationId: Number(values.expiration_type),
      packagePlanRenewalId: values.renewal_cycle,
      changeDate: values.changeDate || null,
      packageAdditionalPermissions:
        values.package_additional?.map(item => ({
          packageAdditionalPermissionId: item.type,
          qty: Number(item.qty)
        })) || []
    },
    dispatch,
    useAuth: true
  });

  if (data) {
    return data;
  }
  return null;
};

export const updateBusinessPackage = (id, values) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `${ENDPOINT.CUSTOMER}/business/${id}/package-change`,
    data: values,
    useAuth: true,
    dispatch
  });

  if (data) {
    return data;
  }
  return null;
};
